export function createAsyncFetcher(apiCall, dataKey, set) {
    return async (...args) => {
        set({ loading: true, error: null });
        try {
            const { code, data } = await apiCall(...args);
            if (code === 200) set({ [dataKey]: data });
            else throw new Error(`Error al cargar ${dataKey}`);
        } catch (err) {
            set({ error: err instanceof Error ? err.message : String(err) });
        } finally {
            set({ loading: false });
        }
    };
}
